// extracted by mini-css-extract-plugin
export default {"productCarousel":"h0-z"};